export const primitives = {
  colorGray50: "#fafbfc",
  colorGray100: "#f4f4f4",
  colorGray200: "#ebedf1",
  colorGray300: "#d7d8da",
  colorGray400: "#c0c4c6",
  colorGray500: "#989ba0",
  colorGray600: "#62646f",
  colorGray700: "#383b41",
  colorGray800: "#262a35",
  colorGray900: "#181e26",
  colorBaseWhite: "#ffffff",
  colorBaseBlack: "#030712",
  colorGray950: "#121519",
  colorBrandBlue200: "#c7e2ff",
  colorBrandBlue500: "#1b88ff",
  colorBrandRed500: "#f04a40",
  colorBrandPink500: "#f43f5e",
  colorBrandGreen500: "#15b8a5",
  colorBrandYellow500: "#e9b309",
  colorBrandYellow50: "#fefce8",
  colorBrandYellow100: "#fef9c2",
  colorBrandYellow200: "#fef08a",
  colorBrandYellow300: "#fedf48",
  colorBrandYellow400: "#facb16",
  colorBrandYellow600: "#ca8906",
  colorBrandYellow700: "#a06107",
  colorBrandYellow800: "#844d0e",
  colorBrandYellow900: "#713f12",
  colorBrandYellow950: "#422006",
  colorBrandGreen50: "#f1fdfa",
  colorBrandGreen100: "#cbfbf1",
  colorBrandGreen200: "#99f6e4",
  colorBrandGreen300: "#5ee9d5",
  colorBrandGreen400: "#2ed4bf",
  colorBrandGreen600: "#0d9487",
  colorBrandGreen700: "#0f756e",
  colorBrandGreen800: "#125e59",
  colorBrandGreen900: "#134e4a",
  colorBrandGreen950: "#052f2e",
  colorBrandPink50: "#fff1f2",
  colorBrandPink100: "#ffe3e5",
  colorBrandPink200: "#feccd3",
  colorBrandPink300: "#fda3af",
  colorBrandPink400: "#fb7084",
  colorBrandPink600: "#e11d48",
  colorBrandPink700: "#bf123c",
  colorBrandPink800: "#9f1239",
  colorBrandPink900: "#871338",
  colorBrandPink950: "#4c0519",
  colorBrandRed50: "#fef2f2",
  colorBrandRed100: "#fee1e2",
  colorBrandRed200: "#fec9c9",
  colorBrandRed300: "#fca4a4",
  colorBrandRed400: "#f87070",
  colorBrandRed600: "#dc2627",
  colorBrandRed700: "#ba1d1c",
  colorBrandRed800: "#991b1b",
  colorBrandRed900: "#801d1d",
  colorBrandRed950: "#450a0a",
  colorBrandSilver400: "#95a2b8",
  colorBrandPurple50: "#f5f3ff",
  colorBrandPurple100: "#ece8fe",
  colorBrandPurple200: "#ddd6fe",
  colorBrandPurple300: "#c4b5fd",
  colorBrandPurple400: "#a68afb",
  colorBrandPurple500: "#8b5cf7",
  colorBrandPurple600: "#7c3aec",
  colorBrandPurple700: "#6d28d9",
  colorBrandPurple800: "#5c21b7",
  colorBrandPurple900: "#4c1d95",
  colorBrandPurple950: "#2e0f65",
  colorBrandBlue50: "#e0efff",
  colorBrandBlue100: "#dce9fe",
  colorBrandBlue300: "#93c4fd",
  colorBrandBlue400: "#5fa4fa",
  colorBrandBlue600: "#2563ea",
  colorBrandBlue700: "#1d4fd8",
  colorBrandBlue800: "#1e3a89",
  colorBrandBlue950: "#172553",
  colorBrandRedTn: "#e11936",
  colorGray900Opacity: "#181e267f",
  colorOpacityWhite50: "#ffffff0a",
  colorOpacityWhite100: "#ffffff0f",
  colorOpacityWhite200: "#ffffff14",
  colorOpacityWhite300: "#ffffff28",
  colorOpacityWhite400: "#ffffff3d",
  colorOpacityWhite500: "#ffffff5b",
  colorOpacityWhite600: "#ffffff7a",
  colorOpacityWhite700: "#ffffffa3",
  colorOpacityWhite800: "#ffffffcc",
  colorOpacityWhite900: "#ffffffea",
  colorOpacityBlack50: "#0000000a",
  colorOpacityBlack100: "#0000000f",
  colorOpacityBlack200: "#00000014",
  colorOpacityBlack300: "#00000028",
  colorOpacityBlack400: "#0000003d",
  colorOpacityBlack500: "#0000005b",
  colorOpacityBlack600: "#0000007a",
  colorOpacityBlack700: "#000000a3",
  colorOpacityBlack800: "#000000cc",
  colorOpacityBlack900: "#000000ea",
};
